const initialState = {
  cart: JSON.parse(localStorage.getItem('cart')) || [],
  cartCount: Number(localStorage.getItem('Café Total')) || 0,
  cartTotal: Number(localStorage.getItem('Café Inca')) || 0,
  products: [],
  loading: true,
};

export default initialState;
